import * as React from 'react'
import styled from 'styled-components'
import { Color } from '../../../constants/app.constant'
interface Props {
  glyph: string
  color?: string
  size?: string
}

const IconWrap = (props: Props) => {
  const { glyph: Glyph, ...options } = props

  return (
    <IconWrapper {...options}>
      <Glyph />
    </IconWrapper>
  )
}

const IconWrapper = styled.span<{ color?: string; size?: string }>`
  fill: ${({ color }) => (color ? color : Color.BRAND.PRIMARY)};
  svg {
    width: ${({ size }) => (size ? size : '1em')};
    height: ${({ size }) => (size ? size : '1em')};
    overflow: visible;
    * {
      fill: ${({ color }) => (color ? color : Color.BRAND.PRIMARY)};
      stroke: ${({ color }) => (color ? color : Color.BRAND.PRIMARY)};
    }
  }
`

export default IconWrap



// WEBPACK FOOTER //
// ./src/components/atoms/icon/icon-wrap.tsx